import React from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { isLogin, isPublicRouter } from '../../utils';
import { stateRoot } from '../../store';
import { deveRedirecionarAuditoriaNsir } from '../../helpers/auditoriaNsirRoutes';

const RouteWithLayout = ({ layout: Layout, isPublic, history, component: Component, ...rest }) => {
  const isLoged = isLogin();
  const isRouterPublic = isPublicRouter(history.location.pathname);
  return (
    <Route
      {...rest}
      render={matchProps => {
        const pathname = matchProps.location.pathname;
        const userRole = stateRoot()?.auth?.role;
        if (!isPublic && !isLoged && !isRouterPublic) {
          return (
            <Layout>
              <Redirect to="/login" />
            </Layout>
          );
        }
        if (!isPublic && isLoged && deveRedirecionarAuditoriaNsir({ isLogado: isLoged, pathname, userRole })) {
          return (
            <Layout>
              <Redirect to="/nsirs" />
            </Layout>
          );
        }
        return (
          <Layout>
            <Component {...matchProps} />
          </Layout>
        );
      }}
    />
  );
};

RouteWithLayout.propTypes = {
  component: PropTypes.any.isRequired,
  layout: PropTypes.any.isRequired,
  history: PropTypes.object.isRequired,
  path: PropTypes.string,
  isPublic: PropTypes.bool,
};

RouteWithLayout.defaultValue = {
  isPublic: false
}

export default withRouter(RouteWithLayout);
